/** @jsxImportSource @emotion/react */

import { FeatureNotFoundStyle } from "./style.index";

const FeatureNotFound = () => {
  return (
    <div css={FeatureNotFoundStyle.wrapper}>
      Tính nằng này hiện đang phát triển, vui lòng quay lại sau!
    </div>
  );
};

export default FeatureNotFound;
